
import * as type from "../../types/API/bomScrapLogs";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getBOMScrapLogsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_SCRAP_LOG:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_SCRAP_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_SCRAP_LOG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBOMScrapLogsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_BOM_SCRAP_LOG:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BOM_SCRAP_LOG_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BOM_SCRAP_LOG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMScrapLogsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BOM_SCRAP_LOG:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_BOM_SCRAP_LOG_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_SCRAP_LOG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMScrapLogsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_SCRAP_LOG:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_SCRAP_LOG_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_SCRAP_LOG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 